"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _toConsumableArray = require("C:\\Matiria\\GitHub2\\Website\\FyatLuxCycles\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("C:\\Matiria\\GitHub2\\Website\\FyatLuxCycles\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Matiria\\GitHub2\\Website\\FyatLuxCycles\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Matiria\\GitHub2\\Website\\FyatLuxCycles\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterFromParam = exports.FilterPolyfill = void 0;

var types_1 = require("../types");

var util_1 = require("../util");

var TIMEOUT = 5 * 60 * 1000; // 5 minutes

var JSONRPC_TEMPLATE = {
  jsonrpc: "2.0",
  id: 0
};

var FilterPolyfill = /*#__PURE__*/function () {
  function FilterPolyfill(provider) {
    _classCallCheck(this, FilterPolyfill);

    this.logFilters = new Map(); // <id, filter>

    this.blockFilters = new Set(); // <id>

    this.pendingTransactionFilters = new Set(); // <id, true>

    this.cursors = new Map(); // <id, cursor>

    this.timeouts = new Map(); // <id, setTimeout id>

    this.nextFilterId = (0, types_1.IntNumber)(1);
    this.provider = provider;
  }

  _createClass(FilterPolyfill, [{
    key: "newFilter",
    value: function () {
      var _newFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(param) {
        var filter, id, cursor;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filter = filterFromParam(param);
                id = this.makeFilterId();
                _context.next = 4;
                return this.setInitialCursorPosition(id, filter.fromBlock);

              case 4:
                cursor = _context.sent;
                console.log("Installing new log filter(".concat(id, "):"), filter, "initial cursor position:", cursor);
                this.logFilters.set(id, filter);
                this.setFilterTimeout(id);
                return _context.abrupt("return", (0, util_1.hexStringFromIntNumber)(id));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function newFilter(_x) {
        return _newFilter.apply(this, arguments);
      }

      return newFilter;
    }()
  }, {
    key: "newBlockFilter",
    value: function () {
      var _newBlockFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var id, cursor;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = this.makeFilterId();
                _context2.next = 3;
                return this.setInitialCursorPosition(id, "latest");

              case 3:
                cursor = _context2.sent;
                console.log("Installing new block filter (".concat(id, ") with initial cursor position:"), cursor);
                this.blockFilters.add(id);
                this.setFilterTimeout(id);
                return _context2.abrupt("return", (0, util_1.hexStringFromIntNumber)(id));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function newBlockFilter() {
        return _newBlockFilter.apply(this, arguments);
      }

      return newBlockFilter;
    }()
  }, {
    key: "newPendingTransactionFilter",
    value: function () {
      var _newPendingTransactionFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var id, cursor;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = this.makeFilterId();
                _context3.next = 3;
                return this.setInitialCursorPosition(id, "latest");

              case 3:
                cursor = _context3.sent;
                console.log("Installing new block filter (".concat(id, ") with initial cursor position:"), cursor);
                this.pendingTransactionFilters.add(id);
                this.setFilterTimeout(id);
                return _context3.abrupt("return", (0, util_1.hexStringFromIntNumber)(id));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function newPendingTransactionFilter() {
        return _newPendingTransactionFilter.apply(this, arguments);
      }

      return newPendingTransactionFilter;
    }()
  }, {
    key: "uninstallFilter",
    value: function uninstallFilter(filterId) {
      var id = (0, util_1.intNumberFromHexString)(filterId);
      console.log("Uninstalling filter (".concat(id, ")"));
      this.deleteFilter(id);
      return true;
    }
  }, {
    key: "getFilterChanges",
    value: function getFilterChanges(filterId) {
      var id = (0, util_1.intNumberFromHexString)(filterId);

      if (this.timeouts.has(id)) {
        // extend timeout
        this.setFilterTimeout(id);
      }

      if (this.logFilters.has(id)) {
        return this.getLogFilterChanges(id);
      } else if (this.blockFilters.has(id)) {
        return this.getBlockFilterChanges(id);
      } else if (this.pendingTransactionFilters.has(id)) {
        return this.getPendingTransactionFilterChanges(id);
      }

      return Promise.resolve(filterNotFoundError());
    }
  }, {
    key: "getFilterLogs",
    value: function () {
      var _getFilterLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(filterId) {
        var id, filter;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = (0, util_1.intNumberFromHexString)(filterId);
                filter = this.logFilters.get(id);

                if (filter) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", filterNotFoundError());

              case 4:
                return _context4.abrupt("return", this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  method: "eth_getLogs",
                  params: [paramFromFilter(filter)]
                })));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getFilterLogs(_x2) {
        return _getFilterLogs.apply(this, arguments);
      }

      return getFilterLogs;
    }()
  }, {
    key: "makeFilterId",
    value: function makeFilterId() {
      return (0, types_1.IntNumber)(++this.nextFilterId);
    }
  }, {
    key: "sendAsyncPromise",
    value: function sendAsyncPromise(request) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.provider.sendAsync(request, function (err, response) {
          if (err) {
            return reject(err);
          }

          if (Array.isArray(response) || response == null) {
            return reject(new Error("unexpected response received: ".concat(JSON.stringify(response))));
          }

          resolve(response);
        });
      });
    }
  }, {
    key: "deleteFilter",
    value: function deleteFilter(id) {
      console.log("Deleting filter (".concat(id, ")"));
      this.logFilters.delete(id);
      this.blockFilters.delete(id);
      this.pendingTransactionFilters.delete(id);
      this.cursors.delete(id);
      this.timeouts.delete(id);
    }
  }, {
    key: "getLogFilterChanges",
    value: function () {
      var _getLogFilterChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(id) {
        var filter, cursorPosition, currentBlockHeight, toBlock, response, blocks, highestBlock, newCursorPosition;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                filter = this.logFilters.get(id);
                cursorPosition = this.cursors.get(id);

                if (!(!cursorPosition || !filter)) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", filterNotFoundError());

              case 4:
                _context5.next = 6;
                return this.getCurrentBlockHeight();

              case 6:
                currentBlockHeight = _context5.sent;
                toBlock = filter.toBlock === "latest" ? currentBlockHeight : filter.toBlock;

                if (!(cursorPosition > currentBlockHeight)) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", emptyResult());

              case 10:
                if (!(cursorPosition > filter.toBlock)) {
                  _context5.next = 12;
                  break;
                }

                return _context5.abrupt("return", emptyResult());

              case 12:
                console.log("Fetching logs from ".concat(cursorPosition, " to ").concat(toBlock, " for filter ").concat(id));
                _context5.next = 15;
                return this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  method: "eth_getLogs",
                  params: [paramFromFilter(Object.assign(Object.assign({}, filter), {
                    fromBlock: cursorPosition,
                    toBlock: toBlock
                  }))]
                }));

              case 15:
                response = _context5.sent;

                if (Array.isArray(response.result)) {
                  blocks = response.result.map(function (log) {
                    return (0, util_1.intNumberFromHexString)(log.blockNumber || "0x0");
                  });
                  highestBlock = Math.max.apply(Math, _toConsumableArray(blocks));

                  if (highestBlock && highestBlock > cursorPosition) {
                    newCursorPosition = (0, types_1.IntNumber)(highestBlock + 1);
                    console.log("Moving cursor position for filter (".concat(id, ") from ").concat(cursorPosition, " to ").concat(newCursorPosition));
                    this.cursors.set(id, newCursorPosition);
                  }
                }

                return _context5.abrupt("return", response);

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getLogFilterChanges(_x3) {
        return _getLogFilterChanges.apply(this, arguments);
      }

      return getLogFilterChanges;
    }()
  }, {
    key: "getBlockFilterChanges",
    value: function () {
      var _getBlockFilterChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(id) {
        var _this2 = this;

        var cursorPosition, currentBlockHeight, blocks, newCursorPosition;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                cursorPosition = this.cursors.get(id);

                if (cursorPosition) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", filterNotFoundError());

              case 3:
                _context6.next = 5;
                return this.getCurrentBlockHeight();

              case 5:
                currentBlockHeight = _context6.sent;

                if (!(cursorPosition > currentBlockHeight)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", emptyResult());

              case 8:
                console.log("Fetching blocks from ".concat(cursorPosition, " to ").concat(currentBlockHeight, " for filter (").concat(id, ")"));
                _context6.next = 11;
                return Promise.all( // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                (0, util_1.range)(cursorPosition, currentBlockHeight + 1).map(function (i) {
                  return _this2.getBlockHashByNumber((0, types_1.IntNumber)(i));
                }));

              case 11:
                blocks = _context6.sent.filter(function (hash) {
                  return !!hash;
                });
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                newCursorPosition = (0, types_1.IntNumber)(cursorPosition + blocks.length);
                console.log("Moving cursor position for filter (".concat(id, ") from ").concat(cursorPosition, " to ").concat(newCursorPosition));
                this.cursors.set(id, newCursorPosition);
                return _context6.abrupt("return", Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  result: blocks
                }));

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getBlockFilterChanges(_x4) {
        return _getBlockFilterChanges.apply(this, arguments);
      }

      return getBlockFilterChanges;
    }()
  }, {
    key: "getPendingTransactionFilterChanges",
    value: function () {
      var _getPendingTransactionFilterChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_id) {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", Promise.resolve(emptyResult()));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getPendingTransactionFilterChanges(_x5) {
        return _getPendingTransactionFilterChanges.apply(this, arguments);
      }

      return getPendingTransactionFilterChanges;
    }()
  }, {
    key: "setInitialCursorPosition",
    value: function () {
      var _setInitialCursorPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(id, startBlock) {
        var currentBlockHeight, initialCursorPosition;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.getCurrentBlockHeight();

              case 2:
                currentBlockHeight = _context8.sent;
                initialCursorPosition = typeof startBlock === "number" && startBlock > currentBlockHeight ? startBlock : currentBlockHeight;
                this.cursors.set(id, initialCursorPosition);
                return _context8.abrupt("return", initialCursorPosition);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setInitialCursorPosition(_x6, _x7) {
        return _setInitialCursorPosition.apply(this, arguments);
      }

      return setInitialCursorPosition;
    }()
  }, {
    key: "setFilterTimeout",
    value: function setFilterTimeout(id) {
      var _this3 = this;

      var existing = this.timeouts.get(id);

      if (existing) {
        window.clearTimeout(existing);
      }

      var timeout = window.setTimeout(function () {
        console.log("Filter (".concat(id, ") timed out"));

        _this3.deleteFilter(id);
      }, TIMEOUT);
      this.timeouts.set(id, timeout);
    }
  }, {
    key: "getCurrentBlockHeight",
    value: function () {
      var _getCurrentBlockHeight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _yield$this$sendAsync, result;

        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  method: "eth_blockNumber",
                  params: []
                }));

              case 2:
                _yield$this$sendAsync = _context9.sent;
                result = _yield$this$sendAsync.result;
                return _context9.abrupt("return", (0, util_1.intNumberFromHexString)((0, util_1.ensureHexString)(result)));

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getCurrentBlockHeight() {
        return _getCurrentBlockHeight.apply(this, arguments);
      }

      return getCurrentBlockHeight;
    }()
  }, {
    key: "getBlockHashByNumber",
    value: function () {
      var _getBlockHashByNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(blockNumber) {
        var response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  method: "eth_getBlockByNumber",
                  params: [(0, util_1.hexStringFromIntNumber)(blockNumber), false]
                }));

              case 2:
                response = _context10.sent;

                if (!(response.result && typeof response.result.hash === "string")) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt("return", (0, util_1.ensureHexString)(response.result.hash));

              case 5:
                return _context10.abrupt("return", null);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getBlockHashByNumber(_x8) {
        return _getBlockHashByNumber.apply(this, arguments);
      }

      return getBlockHashByNumber;
    }()
  }]);

  return FilterPolyfill;
}();

exports.FilterPolyfill = FilterPolyfill;

function filterFromParam(param) {
  return {
    fromBlock: intBlockHeightFromHexBlockHeight(param.fromBlock),
    toBlock: intBlockHeightFromHexBlockHeight(param.toBlock),
    addresses: param.address === undefined ? null : Array.isArray(param.address) ? param.address : [param.address],
    topics: param.topics || []
  };
}

exports.filterFromParam = filterFromParam;

function paramFromFilter(filter) {
  var param = {
    fromBlock: hexBlockHeightFromIntBlockHeight(filter.fromBlock),
    toBlock: hexBlockHeightFromIntBlockHeight(filter.toBlock),
    topics: filter.topics
  };

  if (filter.addresses !== null) {
    param.address = filter.addresses;
  }

  return param;
}

function intBlockHeightFromHexBlockHeight(value) {
  if (value === undefined || value === "latest" || value === "pending") {
    return "latest";
  } else if (value === "earliest") {
    return (0, types_1.IntNumber)(0);
  } else if ((0, util_1.isHexString)(value)) {
    return (0, util_1.intNumberFromHexString)(value);
  }

  throw new Error("Invalid block option: ".concat(String(value)));
}

function hexBlockHeightFromIntBlockHeight(value) {
  if (value === "latest") {
    return value;
  }

  return (0, util_1.hexStringFromIntNumber)(value);
}

function filterNotFoundError() {
  return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
    error: {
      code: -32000,
      message: "filter not found"
    }
  });
}

function emptyResult() {
  return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
    result: []
  });
}